(function () {
  if (window.__ATS_TILE_PRODUCT_INITIALIZED__) return;
  window.__ATS_TILE_PRODUCT_INITIALIZED__ = true;

  var state = {
    area: 1,
    wastage: false,
  };

  var moneyFormatter = new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
  });

  function parseNumber(value, fallback) {
    var parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function clampArea(value) {
    var area = parseNumber(value, 0.0001);
    return Math.max(area, 0.0001);
  }

  function formatArea(value) {
    var rounded = Math.round(value * 10000) / 10000;
    return rounded.toFixed(4);
  }

  function formatMoney(cents) {
    return moneyFormatter.format((parseInt(cents, 10) || 0) / 100);
  }

  function getCalculators() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-tile-calculator]'));
  }

  function getConfig() {
    var calculator = getCalculators()[0];
    return {
      m2PerBox: Math.max(parseNumber(calculator?.getAttribute('data-m2-per-box'), 1), 0.01),
      priceCents: parseInt(calculator?.getAttribute('data-price-cents'), 10) || 0,
      compareCents: parseInt(calculator?.getAttribute('data-compare-cents'), 10) || 0,
    };
  }

  function calculate() {
    var config = getConfig();
    var requestedArea = clampArea(state.area);
    var effectiveArea = requestedArea * (state.wastage ? 1.15 : 1);
    var boxes = Math.max(1, Math.ceil(effectiveArea / config.m2PerBox));
    var suppliedArea = boxes * config.m2PerBox;

    return {
      requestedArea: requestedArea,
      effectiveArea: effectiveArea,
      boxes: boxes,
      suppliedArea: suppliedArea,
      totalPriceCents: boxes * config.priceCents,
    };
  }

  function notifyQuantityChange(result) {
    window.dispatchEvent(
      new CustomEvent('tile:quantity-change', {
        detail: {
          productRoot: document.querySelector('[data-product-main]'),
          boxes: result.boxes,
          requestedArea: result.requestedArea,
          suppliedArea: result.suppliedArea,
          wastage: state.wastage,
        },
      }),
    );
  }

  function updateInputs(sourceInput) {
    document.querySelectorAll('[data-tile-area-input]').forEach(function (input) {
      if (input === sourceInput && document.activeElement === input) return;
      input.value = formatArea(state.area);
    });

    document.querySelectorAll('[data-tile-wastage-toggle]').forEach(function (input) {
      input.checked = state.wastage;
    });
  }

  function updateCalculatedFields(sourceInput, options) {
    var result = calculate();

    updateInputs(sourceInput);

    document.querySelectorAll('[data-tile-box-count]').forEach(function (element) {
      element.textContent = result.boxes;
    });

    document.querySelectorAll('[data-tile-total-area]').forEach(function (element) {
      element.textContent = formatArea(result.suppliedArea);
    });

    document.querySelectorAll('[data-tile-total-price]').forEach(function (element) {
      element.textContent = formatMoney(result.totalPriceCents);
    });

    document.querySelectorAll('[data-tile-quantity-input]').forEach(function (input) {
      input.value = result.boxes;
    });

    document.querySelectorAll('[data-tile-requested-area-property]').forEach(function (input) {
      input.value = formatArea(result.requestedArea);
    });

    document.querySelectorAll('[data-tile-wastage-property]').forEach(function (input) {
      input.value = state.wastage ? 'Yes' : 'No';
    });

    document.querySelectorAll('[data-tile-supplied-area-property]').forEach(function (input) {
      input.value = formatArea(result.suppliedArea);
    });

    if (options?.notify) {
      notifyQuantityChange(result);
    }
  }

  function setArea(value, sourceInput) {
    state.area = clampArea(value);
    updateCalculatedFields(sourceInput, { notify: true });
  }

  function bindEvents() {
    document.addEventListener('click', function (event) {
      var minusButton = event.target.closest('[data-tile-area-minus]');
      var plusButton = event.target.closest('[data-tile-area-plus]');

      if (!minusButton && !plusButton) return;

      event.preventDefault();
      setArea(state.area + (plusButton ? 1 : -1));
    });

    document.addEventListener('input', function (event) {
      if (!event.target.matches('[data-tile-area-input]')) return;
      if (event.target.value === '') return;

      setArea(event.target.value, event.target);
    });

    document.addEventListener(
      'blur',
      function (event) {
        if (!event.target.matches('[data-tile-area-input]')) return;
        setArea(event.target.value);
      },
      true,
    );

    document.addEventListener('change', function (event) {
      if (!event.target.matches('[data-tile-wastage-toggle]')) return;

      state.wastage = event.target.checked;
      updateCalculatedFields(null, { notify: true });
    });
  }

  function observeStickySync() {
    var stickyBar = document.querySelector('[data-sticky-atc]');
    if (!stickyBar || stickyBar.dataset.tileObserved === 'true') return;

    stickyBar.dataset.tileObserved = 'true';
    new MutationObserver(function () {
      window.requestAnimationFrame(function () {
        updateCalculatedFields();
      });
    }).observe(stickyBar, {
      attributes: true,
      attributeFilter: ['class', 'aria-hidden'],
      subtree: false,
    });
  }

  function init() {
    if (!getCalculators().length) return;

    var firstInput = document.querySelector('[data-tile-area-input]');
    if (firstInput) {
      state.area = clampArea(firstInput.value);
    }

    var firstWastage = document.querySelector('[data-tile-wastage-toggle]');
    state.wastage = Boolean(firstWastage?.checked);

    updateCalculatedFields();
    observeStickySync();
  }

  bindEvents();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var initQueued = false;
  new MutationObserver(function (mutations) {
    var shouldInit = mutations.some(function (mutation) {
      return Array.prototype.slice.call(mutation.addedNodes).some(function (node) {
        if (!(node instanceof HTMLElement)) return false;
        return node.matches('[data-tile-calculator]') || Boolean(node.querySelector('[data-tile-calculator]'));
      });
    });

    if (!shouldInit || initQueued) return;

    initQueued = true;
    window.requestAnimationFrame(function () {
      initQueued = false;
      init();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
